import type { AxiosResponse } from "axios";

import type {
  CancelableAxiosPromise,
  S3PutSuccess,
} from "cortex/ui/src/service/base";
import { baseService } from "cortex/ui/src/service/base";

interface AlertV3RequestParams extends Record<string, unknown> {
  sources?: Array<string | number>;
  threshold?: number;
}

export const alertV3Service = {
  load(): CancelableAxiosPromise {
    return baseService.get("/api/alerts/v3");
  },

  // eslint-disable-next-line max-params
  new(
    name: string,
    eventNames: string[],
    targets: Array<string | number>,
    users: Array<string | number>,
    params: AlertV3RequestParams,
    description?: string,
    priority?: string,
  ): CancelableAxiosPromise {
    return baseService.post("/api/alert/v3", {
      event_names: eventNames,
      name,
      params,
      targets,
      users,
      description,
      priority,
    });
  },

  // eslint-disable-next-line max-params
  edit(
    alertId: string | number,
    name: string,
    eventNames: string[],
    targets: Array<string | number>,
    users: Array<string | number>,
    params: AlertV3RequestParams,
    description?: string,
    priority?: string,
  ): Promise<AxiosResponse | S3PutSuccess> {
    return baseService.put(`/api/alert/v3/${alertId}`, {
      name,
      params,
      targets,
      users,
      event_names: eventNames,
      description,
      priority,
    });
  },

  delete(alertId: string | number): CancelableAxiosPromise {
    return baseService.delete(`/api/alert/v3/${alertId}`);
  },
};

export default alertV3Service;
